export const PASSWORD_REGEXP =
  /^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*_-]).{8,}$/i

export const PRICE_REGEXP = /\d+(?:\.\d+)?/g
